if (!customElements.get('before-after-tabs')) {
  class BeforeAfterTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.before-after__tab'));
      this.panels = Array.from(this.querySelectorAll('.before-after__panel'));

      if (this.tabs.length < 2) return;

      this.handleClick = this.handleClick.bind(this);

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleClick);
      });
    }

    handleClick(event) {
      this.activate(event.currentTarget.dataset.target);
    }

    activate(target) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.target === target;

        tab.classList.toggle('active', isActive);
        tab.setAttribute('aria-selected', isActive);
      });

      this.panels.forEach((panel) => {
        panel.classList.toggle('active', panel.id === target);
      });
    }

    disconnectedCallback() {
      this.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.handleClick);
      });
    }
  }

  customElements.define('before-after-tabs', BeforeAfterTabs);
}
